<div class="p-6">
  @if (meteringPoint) {
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
            {{ 'meteringpoint.physical.title' | translate }}
          </div>
          <app-value-details
            [collection]="physicalMasterData"
            [data]="meteringPoint"
          ></app-value-details>

        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
            {{ 'meteringpoint.location.title' | translate }}
          </div>
          <app-value-details
            [collection]="locationMasterData"
            [data]="meteringPoint"
          ></app-value-details>
        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
            {{ 'meteringpoint.meterdetails.title' | translate }}
          </div>
          <app-value-details
            [collection]="meteringPointMasterData"
            [data]="meteringPoint"
          ></app-value-details>

          <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
            {{ 'meteringpoint.meter.title' | translate }}
          </div>

          <app-value-details
            [collection]="meterMasterData"
            [data]="meteringPoint"
          ></app-value-details>
        </div>
      </div>

      @if (meteringPoint.children && meteringPoint.children.length > 0) {
        <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold mb-4">
          {{ 'meteringpoint.children.title' | translate }}
        </div>
        <app-table
          [config]="meteringPointChildTable"
          [data]="meteringPoint.children"
        ></app-table>
      }
    </app-card>


  }
</div>
